export { default } from './BottomNavItem';



// WEBPACK FOOTER //
// ./src/components/Auth0Animation/components/BottomNavItem/index.js